import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import apiClient from "common/src/api/ApiClient";

export const fetchUserPage = createAsyncThunk(
    'user/fetch/page',
    async ({page, filter, sort}) => {
        const response = await apiClient.get('/api/v1/user', null, page, filter, sort);
        return response.data.payload;
    }
);

export const fetchUserDetails = createAsyncThunk(
    'user/fetch/details',
    async ({userId}) => {
        const response = await apiClient.get('/api/v1/user/' + userId);
        return response.data.payload
    }
);

export const saveUser = createAsyncThunk(
    'user/save/details',
    async (userData, thunkAPI) => {
        try {
            let response;
            if (userData.id) {
                // Update user if ID is present
                response = await apiClient.put(`/api/v1/user/${userData.id}`, userData);
                thunkAPI.dispatch(cleanupUserById(userData.id));
            } else {
                // Create user if ID is not present
                response = await apiClient.post('/api/v1/user', userData);
            }
            return response.data.payload;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

export const resendUserActivationEmail = createAsyncThunk(
    'user/mutate/resendActivation',
    async (userId, thunkAPI) => {
        try {
            const response = await apiClient.post(`/api/v1/user/${userId}/resend-activation`);
            return thunkAPI.fulfillWithValue(response.data.payload);
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const deleteUser = createAsyncThunk(
    'user/mutate/delete',
    async (userId, thunkAPI) => {
        try {
            const response = await apiClient.delete(`/api/v1/user/${userId}`);
            thunkAPI.dispatch(cleanupUserById(userId));
            return thunkAPI.fulfillWithValue(response.data.payload);
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

const userAPI = createSlice({
    name: 'userAPI',
    initialState: {
        loading: false,
        details: {},
        page: {
            content: [],
            last: false
        },
        detailsLoading: false,
        detailsError: false
    },
    reducers: {
        cleanupUserById: (state, action) => {
            if (action.payload && state[action.payload]) {
                delete state[action.payload];
            }
            state.details = undefined;
        },
    },
    extraReducers: (builder) => {builder
        .addCase(fetchUserPage.fulfilled, (state, action) => {
            if (!state.currentQueryRequestId || state.currentQueryRequestId === action?.meta.requestId) {
                state.loading = false;
                state.error = false;
                state.page = action.payload;
            }
        }).addCase(fetchUserPage.pending, (state, action) => {
            state.currentQueryRequestId = action?.meta.requestId;
            state.loading = true;
        }).addCase(fetchUserPage.rejected, (state, action) => {
            if (state.currentQueryRequestId === action.meta.requestId) {
                state.loading = false;
                state.currentQueryRequestId = null;
                state.error = true;
            }
        }).addCase(fetchUserDetails.pending, (state, action) => {
            state.detailsLoading = true;
        }).addCase(fetchUserDetails.fulfilled, (state, action) => {
            state.detailsLoading = false;
            state.detailsError = false;
            state.details = action.payload;
            state[action.payload.id] = action.payload;
        }).addCase(fetchUserDetails.rejected, (state, action) => {
            state.detailsLoading = false;
            state.detailsError = true;
        })
        .addCase(saveUser.fulfilled, (state, action) => {
            if (!state.page) {
                state.page = {};
            }
            state.page.content = [];
            state.page.last = false;
            state.loading = true;

        })
        .addCase(deleteUser.fulfilled, (state, action) => {
            if (!state.page) {
                state.page = {};
            }
            state.page.content = [];
            state.page.last = false;
            state.loading = true;
        })
    }
});


export const {cleanupUserById} = userAPI.actions;

export default userAPI.reducer;
